/**
 * Get Socket.IO URL with proper protocol (wss:// for HTTPS pages, ws:// for HTTP)
 * This prevents Mixed Content errors when page is loaded over HTTPS
 */
export function getSocketUrl(): string {
  // CRITICAL FIX: Check for explicit socket URL first (for local dev)
  const socketUrl =
    (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_SOCKET_URL) ||
    process.env.VITE_SOCKET_URL ||
    process.env.REACT_APP_SOCKET_URL ||
    '';
  
  if (socketUrl) {
    const cleanUrl = socketUrl.replace(/\/+$/, '');
    return cleanUrl;
  }
  
  // Fallback to API URL
  const rawBase =
    (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_API_URL) ||
    process.env.VITE_API_URL ||
    process.env.REACT_APP_API_URL ||
    '';
  
  let baseUrl = rawBase.replace(/\/+$/, '');
  
  // CRITICAL FIX: For local dev, if no API URL is set, default to localhost:5050
  if (!baseUrl && typeof window !== 'undefined') {
    // Check if we're in local dev (localhost or 127.0.0.1)
    const isLocalDev = window.location.hostname === 'localhost' || 
                       window.location.hostname === '127.0.0.1' ||
                       window.location.hostname === '';
    
    if (isLocalDev) {
      // Default to localhost:5050 for local dev (matches server.js PORT)
      baseUrl = 'http://localhost:5050';
    } else {
      // Use window.location.origin for production
      baseUrl = window.location.origin;
    }
  }
  
  // If page is loaded over HTTPS, ensure baseUrl uses https://
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    // Replace http:// with https://
    baseUrl = baseUrl.replace(/^http:\/\//, 'https://');
  }
  
  return baseUrl;
}

